import {
  Entity,
  Column,
  PrimaryGeneratedColumn,
  OneToOne,
  JoinColumn,
  CreateDateColumn,
  UpdateDateColumn,
} from 'typeorm';

import {
  ProposalPricingSummaryStatus,
} from '../../interface/proposals/proposals-response.interface';
import { ProposalsEntity } from './proposals.entity';


@Entity('proposal_pricing_summary')
export class ProposalPricingSummaryEntity {
  @PrimaryGeneratedColumn('uuid')
  id!: string;

  @OneToOne(() => ProposalsEntity, proposal => proposal.proposal_pricing_summary)
  @JoinColumn({ name: 'proposal_id', referencedColumnName: 'id' })
  proposal!: ProposalsEntity;

  @Column({ type: 'decimal', precision: 15, scale: 2 })
  subtotal!: number;

  @Column({ type: 'decimal', precision: 15, scale: 2 })
  shipping_fee!: number;

  @Column({ type: 'decimal', precision: 15, scale: 2 })
  markup!: number;

  @Column({ type: 'decimal', precision: 15, scale: 2 })
  misc!: number;

  @Column({ type: 'decimal', precision: 15, scale: 2 })
  approval_discount!: number;

  @Column({ type: 'decimal', precision: 15, scale: 2 })
  discount_percent!: number;

  @Column({ type: 'decimal', precision: 15, scale: 2 })
  discount_amount!: number;

  @Column({ type: 'decimal', precision: 15, scale: 2 })
  total_ex_vat!: number;

  @Column({ type: 'decimal', precision: 15, scale: 2 })
  total_inc_vat!: number;

  @Column({ type: 'decimal', precision: 15, scale: 2 })
  total_profit!: number;

  @Column({ type: 'decimal', precision: 15, scale: 2 })
  grand_total!: number;

  @Column({ nullable: true })
  lead_time?: string | null;

  @CreateDateColumn()
  created_at!: Date;

  @UpdateDateColumn()
  updated_at!: Date;

  @Column({ type: 'varchar' })
  status!: ProposalPricingSummaryStatus;
}